export class PlayerPosition {
  public static Goalkeeper = 'goalkeeper';
  public static Defender = 'defender';
  public static Midfielder = 'midfielder';
  public static Forward = 'attacker';
}
